export default "__VITE_ASSET__GZXs0Nf2__"